// Client document subscriptions (#3814) call WebAPI directly via api.webAPIFetch;
// there is no WebLayer MessageID for them. Every call resolves to { data, error, etag };
// error.status holds the HTTP status when the API refused the request.

export const PRECONDITION_FAILED = 412;

const request = async (api, route, options = {}) => {
    try {
        const response = await api.webAPIFetch(route, options);
        if (!response.ok) {
            let detail = `HTTP ${response.status} ${response.statusText || ''}`.trim();
            try {
                const problem = await response.json();
                detail = problem.detail || problem.title || detail;
            } catch {
                // Not a ProblemDetails body; keep the status text.
            }
            const error = new Error(detail);
            error.status = response.status;
            return { data: null, error, etag: null };
        }
        const etag = (response.headers && response.headers.get('ETag')) || null;
        if (response.status === 204) {
            return { data: null, error: null, etag };
        }
        return { data: await response.json(), error: null, etag };
    } catch (error) {
        return { data: null, error, etag: null };
    }
};

const clientRoute = (clientID) =>
    `/api/clients/${encodeURIComponent(clientID)}/document-subscriptions`;

export const getSubscribableRoles = (api) =>
    request(api, '/api/document-subscriptions/roles');

export const getSubscribableDocuments = (api) =>
    request(api, '/api/document-subscriptions/documents');

export const getDocumentGroups = (api) =>
    request(api, '/api/document-subscriptions/groups');

export const getClientSubscriptions = (api, clientID) =>
    request(api, clientRoute(clientID));

// Replaces the client's whole set: roles is [{ roleTypeID, documentIDs }] for every role.
// etag is the one from loading the subscriptions; the API refuses the save (412) if
// someone else has saved since.
export const saveClientSubscriptions = (api, clientID, roles, etag) =>
    request(api, clientRoute(clientID), {
        method: 'PUT',
        headers: etag ? { 'If-Match': etag } : {},
        body: JSON.stringify({
            Roles: roles.map((r) => ({ RoleTypeID: r.roleTypeID, DocumentIDs: r.documentIDs })),
        }),
    });
